import { PropsWithChildren, useReducer } from 'react';
import { SettingsContext } from './context';
import { reducer } from './utils';
import { initialState } from './initialState';
import { useInstallPwaPrompt } from './hooks/useInstallPwaPrompt';

/** @todo добавить сюда состояния отображения куки баннера и блока предлагающего установку PWA
 * и переписать DrawerContext на одно состояние
 */
export const SettingsProvider = ({ children }: PropsWithChildren) => {
  const [settings, dispatch] = useReducer(reducer, initialState);

  const pwaPromptTools = useInstallPwaPrompt();

  return (
    <SettingsContext.Provider
      value={{
        ...settings,
        setSettings: dispatch,
        pwa: pwaPromptTools
      }}>
      {children}
    </SettingsContext.Provider>
  );
};
